/* eslint-disable import/no-unused-modules */

import ControlledSellerInquiry from "./components/ControlledSellerInquiry";
import ENTITY_TYPES from "./constants/entityTypes";
import INQUIRY_TYPES from "./constants/inquiryTypes";
import withCreateSellerInquiry from "./utilities/withCreateSellerInquiry";
import * as traits from "./traits";

const SellerInquiry = withCreateSellerInquiry(ControlledSellerInquiry);

export { SellerInquiry, ENTITY_TYPES, INQUIRY_TYPES, traits };
